import { useMemo } from "react";
import { useAppSelector } from "../framework/customStore";
import { TypedOption } from "../models/common/typedOption";
import { useHistory } from "react-router-dom";

export const useAppOptionValue = <T>(code: string): [T, boolean] => {
    const parameters = useAppSelector((state) => state.owner?.parameters);

    const value = useMemo(() => {
        const option = parameters?.find((p) => p.code === code.toLowerCase());

        if (option) {
            return <T>new TypedOption(option).getTypedValue();
        }
    }, [parameters, code]);

    return [value, !parameters || parameters.length === 0];
};

export const useAppOptionValueEquals = (
    code: string,
    value: any
): [boolean, boolean] => {
    const [optionValue, loading] = useAppOptionValue(code);
    return [optionValue === value, loading];
};

export const useVerifyOptionEnabled = (code: string, active = true) => {
    const history = useHistory();
    const [enabled, loading] = useAppOptionValueEquals(code, true);

    if (active && !loading && !enabled) {
        history.push("/");
    }
};
